import { MoveUpRight } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { getAllPaginatedNews } from "../../API/News/newsService";

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/ui/pagination";
import { News } from "../../data/types";
import img from "../../images/Antoine_Meyssonnier2.jpg";
import { useScrollToTop } from "../../hooks/hooks";

function AllNews() {
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

  const [news, setNews] = useState<News[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const fetchData = async () => {
    const response = await getAllPaginatedNews(page);
    setNews(response?.news);
    setTotalPages(response?.totalPages);
  };
  useEffect(() => {
    fetchData();
  }, [page]);

  const handleNextPageChange = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  const handlePreviousPageChange = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  useScrollToTop();
  const monthAbbreviations: { [key: number]: string } = {
    1: "janv.",
    2: "fév.",
    3: "mars",
    4: "avr.",
    5: "mai",
    6: "juin",
    7: "juil.",
    8: "août",
    9: "sept.",
    10: "oct.",
    11: "nov.",
    12: "déc.",
  };

  return (
    <>
      <div className="mb-10 ">
        <section
          className="p-32 text-center bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="font-bold text-center text-white text-7xl">
            {"Actualités"}
          </h1>
        </section>

        <div className="container mx-auto mt-32 mb-20 md:px-40 sm:px-40">
          <div className="grid gap-20 lg:grid-cols-3">
            {news &&
              news.map((news: any) => (
                <div className="bg-[#ffffff] w-full relative" key={news.id}>
                  <div className="w-full mb-44">
                    <div className="relative">
                      <img
                        src={`${uploadUrl}/news/${news.image}`}
                        className={`w-full  rounded-[10px]   `}
                        alt=""
                      />

                      <div className=" absolute w-full top-[162px]  p-5 pt-0">
                        <div className="relative w-full bg-white rounded-[10px] shadow-lg  border-[#027BC0] border-b-4">
                          <div className="p-5 text-sm font-bold truncate">
                            {news.title}
                          </div>
                          <p className="w-full pl-5 ">
                            {news && news.desc && (
                              <div
                                className="w-full "
                                dangerouslySetInnerHTML={{
                                  __html:
                                    news.desc
                                      .substring(0, 80)
                                      .replace(/<\/?strong>/g, "") +
                                    (news.desc.length > 80 ? "..." : ""),
                                }}
                              />
                            )}
                          </p>

                          <div className="w-full pb-5 pl-5 mt-5">
                            <Link
                              to={`/actualités/${news.slug}`}
                              className="group"
                            >
                              <Button
                                variant="outline"
                                className="rounded-lg group-hover:bg-primary "
                              >
                                <span className="group-hover:text-white">
                                  CONSULTER
                                </span>{" "}
                                <MoveUpRight className="w-2 h-2 ml-2 group-hover:text-white" />
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`absolute w-[70px] h-[94px] top-[30px] left-[30px]  bg-[url(src/images/vector.svg)]`}
                      >
                        <div className="relative w-full h-[37px] top-[21px] left-[21px] flex justify-center">
                          <div className="absolute top-0 left-[1px]  font-bold text-white text-[26px] tracking-[0] leading-[normal] whitespace-nowrap">
                            {new Date(news.date).getDate()}
                          </div>
                          <div className="absolute top-[27px]  left-[0px]   font-medium text-white-color01 text-sm tracking-[0] leading-[normal] whitespace-nowrap text-white">
                            {
                              monthAbbreviations[
                                new Date(news.date).getMonth() + 1
                              ]
                            }
                          </div>
                          <div className="absolute top-[47px] -left-[2px]   font-medium text-white   text-sm tracking-[0] leading-[normal] whitespace-nowrap">
                            {new Date(news.date).toLocaleDateString("fr-FR", {
                              year: "numeric",
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="flex justify-center">
          <Pagination>
            <PaginationContent>
              <PaginationItem>
                <PaginationPrevious
                  className="cursor-pointer hover:bg-transparent"
                  onClick={handlePreviousPageChange}
                />
              </PaginationItem>
              {[...Array(totalPages)].map((_, index) => (
                <PaginationItem key={index}>
                  <PaginationLink
                    className="cursor-pointer hover:bg-transparent"
                    onClick={() => setPage(index + 1)}
                  >
                    <Button
                      variant="outline"
                      size="icon"
                      className="w-10 h-10 text-white rounded-full bg-primary "
                    >
                      {index + 1}
                    </Button>
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem>
                <PaginationNext
                  onClick={handleNextPageChange}
                  className="cursor-pointer hover:bg-transparent"
                />
              </PaginationItem>
            </PaginationContent>
          </Pagination>
        </div>
      </div>
    </>
  );
}

export default AllNews;
